import Event from '../utils/event';
import GameModel from './GameModel';
import GlobalDispatcher from '../events/GlobalDispatcher';
import eWSEventId from '../api/eWSEventId';
import { makeBet } from '../api/wsRequests';
import { formatCurrency } from '../utils/currency';
import MessageAdapter from '../messageAdapter/MessageAdapter';

export default class BetModel {
  constructor() {
    //todo: Hack. defaultBetIndex must come in the "auth" package
    const betIndex = window.OPWrapperService.config.defaultBetIndex || 0;
    this._betAmount = window.OPWrapperService.freeBetsController.isFirstFreeBet || window.OPWrapperService.freeBetsController.isActive
      ? window.OPWrapperService.freeBetsController.data.bet
      : GameModel.availableBets[betIndex];
    this._autoBet = false;

    this._takeCoef = 2;
    this._autoTake = false;

    this.initBetButtons();

    this.betID = null;
    this.roundID = null;

    this.minTakeCoef = 1.35;

    this._waitingForResponse = false;

    this.onChange = new Event();
    this.onWaitingForResponseChanged = new Event();

    GlobalDispatcher.add(eWSEventId.EWEI_FINISH, this._onFinish, this);
    GlobalDispatcher.add(eWSEventId.EWEI_TAKE, this._onTake, this);
    GlobalDispatcher.add(eWSEventId.EWEI_BALANCE, this._onBalance, this);
  }

  setData(data) {
    this.betAmount = data.amount;
    this.betID = data.betId;
    this.roundID = data.roundId;
    this.initBetButtons();
    if (data.autoTake) {
      this.autoTake = true;
      this.takeCoef = data.autoTake;
    }
    if (this.roundID) {
      MessageAdapter.trySendRoundStart();
    }
  }

  initBetButtons() {
    const availableBets = GameModel ? GameModel.availableBets : null;
    const i = availableBets ? availableBets.length : 0;
    const urlParser = window.OPUtility.urlParser;
    const isDirectOrder = urlParser.getParam('casinoId') === '8961f944-a445-4fce-bcb5-44d7eaf59e99' && urlParser.getParam('pid') === '629';
    const crushGamesBetButtonValues = OPWrapperService.config.crushGamesBetButtonValues && OPWrapperService.config.crushGamesBetButtonValues[GameModel.currency];
    if (isDirectOrder) {
      this.betsButtons = [availableBets[0], availableBets[1], availableBets[2], availableBets[3]];
    } else if (crushGamesBetButtonValues) {
      this.betsButtons = [crushGamesBetButtonValues[0], crushGamesBetButtonValues[1], crushGamesBetButtonValues[2], crushGamesBetButtonValues[3]];
    } else {
      this.betsButtons = [availableBets[i - 4], availableBets[i - 3], availableBets[i - 2], availableBets[i - 1]]
    }
  }

  get formatBetAmount() {
    return `${formatCurrency(this._betAmount, GameModel.decimal)} ${GameModel.currency}`;
  }

  get formatTakeCoef() {
    return `×${this._takeCoef.toFixed(2)}`;
  }

  set autoBet(value) {
    const isFreeBets = window.OPWrapperService.freeBetsController.isFreeBets || window.OPWrapperService.freeBetsController.data.status === window.OPWrapperService.freeBetsController.eFreeBetsStatusType.EFBST_ACTIVE;
    this._autoBet = isFreeBets || this.blocked ? false : !!value;
    this.onChange.call();
  }

  get autoBet() {
    return this._autoBet;
  }

  set autoTake(value) {
    this._autoTake = !!value;
    this.onChange.call();
  }

  get autoTake() {
    return this._autoTake;
  }

  set betAmount(value) {
    this._betAmount = value;
    MessageAdapter.betChange(this._betAmount);
    this.onChange.call();
  }

  checkAndSetBetAmount(value) {
    value = value.toFixed(GameModel.decimal);
    value = Math.min(value, GameModel.maxBet);
    value = Math.max(value, GameModel.minBetAmount);
    this._betAmount = value;
    MessageAdapter.betChange(this._betAmount);
    this.onChange.call();
  }

  get betAmount() {
    return this._betAmount;
  }

  set takeCoef(value) {
    this._takeCoef = Math.max(this.minTakeCoef, value);
    this.onChange.call();
  }

  get takeCoef() {
    return this._takeCoef;
  }

  set waitingForResponse(value) {
    this._waitingForResponse = !!value;
    this.onWaitingForResponseChanged.call();
    this.onChange.call();
    this._updateOtherBetsIfFreeBets();
  }

  get waitingForResponse() {
    return this._waitingForResponse;
  }

  get choiceBlocked() {
    return this._waitingForResponse || this.betID !== null || this.blocked;
  }

  set blocked(value) {
    this._blocked = value;
  }

  get blocked() {
    return this._blocked && !this.betID;
  }
  increaseBet() {
    const index = GameModel.availableBets.findIndex(bet => bet > this._betAmount);
    let value = GameModel.availableBets[index];
    value = value ? value : GameModel.maxBet;
    value = Math.min(value, GameModel.maxBet);
    value = Math.max(GameModel.minBetAmount, value);
    if (this._betAmount === value) return;
    this._betAmount = value;
    MessageAdapter.betChange(this._betAmount);
    this.onChange.call();
  }

  decreaseBet() {
    const index = GameModel.availableBets.findIndex(bet => bet >= this._betAmount);
    let value = GameModel.availableBets[index - 1];
    value = value ? value : GameModel.minBetAmount;
    value = Math.max(GameModel.minBetAmount, value);
    if (this._betAmount === value) return;
    this._betAmount = value;
    MessageAdapter.betChange(this._betAmount);
    this.onChange.call();
  }

  increaseTakeCoef() {
    let value = this._takeCoef + 0.1;
    this._takeCoef = Math.max(this.minTakeCoef, value);
    this.onChange.call();
  }

  decreaseTakeCoef() {
    const value = this._takeCoef - 0.1;
    this._takeCoef = Math.max(this.minTakeCoef, value);
    this.onChange.call();
  }

  setBetInfo(betID, roundID, amount) {
    if (amount) this.betAmount = amount;
    this.betID = betID;
    this.roundID = roundID;
    if (window.OPWrapperService.freeBetsController.isFirstFreeBet || window.OPWrapperService.freeBetsController.isLastFreeBet || window.OPWrapperService.realityCheck.blockedGame) this.autoBet = false;
    this._updateOtherBetsIfFreeBets();

    if (this.roundID) {
      MessageAdapter.trySendRoundStart();
    }
    this.onChange.call();
  }

  onDelete() {
    GlobalDispatcher.remove(eWSEventId.EWEI_FINISH, this._onFinish, this);
    GlobalDispatcher.remove(eWSEventId.EWEI_TAKE, this._onTake, this);
  }

  _onFinish() {
    if (this.roundID && this.roundID !== GameModel.roundID && !this.waitingForResponse) return;
    if (window.OPWrapperService.freeBetsController.isFirstFreeBet || window.OPWrapperService.freeBetsController.isLastFreeBet || window.OPWrapperService.realityCheck.blockedGame) this.autoBet = false;
    if (this._autoBet && !this.waitingForResponse) {
      makeBet(this._betAmount, this);
    }
  }

  _onTake(data) {
    if (this.betID === data.params.betId) {
      this.setBetInfo(null, null);
      OPWrapperService.ControllerStatistic.win = data.params.winAmount;
      if (!GameModel.bets.find(betModel => !!betModel.betID)) OPWrapperService.realityCheck.blockedRealityCheck = false;
    }
    if (window.OPWrapperService.freeBetsController.isFirstFreeBet || window.OPWrapperService.freeBetsController.isLastFreeBet || window.OPWrapperService.realityCheck.blockedGame) this.autoBet = false;
  }

  _onBalance() {
    if (window.OPWrapperService.freeBetsController.data.status === window.OPWrapperService.freeBetsController.eFreeBetsStatusType.EFBST_PLAYED) {
      this.checkAndSetBetAmount(GameModel.availableBets[window.OPWrapperService.config.defaultBetIndex]);
    }
  }

  _updateOtherBetsIfFreeBets() {
    if (window.OPWrapperService.freeBetsController.isFreeBets
      || window.OPWrapperService.freeBetsController.data.status === window.OPWrapperService.freeBetsController.eFreeBetsStatusType.EFBST_ACTIVE
    ) {
      GameModel.bets.forEach(bet => {
        if (bet !== this) bet.onChange.call();
      });
    }
  }
}
